import { render, staticRenderFns } from "./order_purchase_detail.vue?vue&type=template&id=64253c6f&scoped=true&"
import script from "./order_purchase_detail.vue?vue&type=script&lang=js&"
export * from "./order_purchase_detail.vue?vue&type=script&lang=js&"
import style0 from "./order_purchase_detail.vue?vue&type=style&index=0&id=64253c6f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64253c6f",
  null
  
)

export default component.exports